import { useCallback } from "react"

import { VaultDepositFormValue } from "#/shared/types"
import { ComponentStepProps, useStepperModalContext } from "#/ui/Modal"

import VaultDepositForm from "./VaultDepositForm"

export default function VaultDepositStep({
  onClickContinue,
}: ComponentStepProps) {
  const { values: initialValues, setValues } =
    useStepperModalContext<VaultDepositFormValue>()

  const handelSubmitForm = useCallback(
    (values: VaultDepositFormValue) => {
      setValues(values)
      onClickContinue()
    },
    [onClickContinue, setValues],
  )

  return (
    <VaultDepositForm
      initialValues={initialValues}
      onSubmitForm={handelSubmitForm}
    />
  )
}
